import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Button } from '@mui/material';
import { Close } from '@carbon/icons-react';




import { Grid } from '@mui/material';
import useStore from '../../store/useStore';
import StatementCardEvents from './StatementCardEvents';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';



function renderStyleifPublished() {
  const tags = document.getElementsByClassName('ituMainNav'); //search class in itu wordpress theme

  if (tags.length > 0) {
    // contains.
    return 'ituContainer grid fullWidthCards'; //class for wordpress
  } else return 'ituContainer grid fullWidthCards'; //class in standalone react
}


const filtersarray = ['searchEvent', 'SectorEvent', 'Types', 'MeetingGroup', 'Formats', 'SectorGroups'];



const loadingBgColor = '#DFF2F8'


const CardViewEvents = () => {

  const {
    filters,
    setFilter,
  } = useStore((state: any) => ({
    filters: state.filters,
    setFilter: state.setFilter,
  }));


  //reset all state filters
  function resetAllFilters() {
    filtersarray.map((filter) => {
      setFilter(filter, '')
    })
  }

  const { cards } = useStore((state: any) => ({ cards: state.MUIdataEvents.rows }));
  const { datasource } = useStore((state: any) => ({ datasource: state.settings.params.datasource }));

  // Get pagination information from state
  const { currentEventPage, eventsPerPage, changeCurrentEventPage } = useStore((state: any) => ({
    currentEventPage: state.currentEventPage,
    eventsPerPage: state.eventsPerPage,
    changeCurrentEventPage: state.changeCurrentEventPage,
  }));

  //calculate pagination slice interval
  const indexOfLastPost = currentEventPage * eventsPerPage;
  const indexOfFirstPost = indexOfLastPost - eventsPerPage;

  //slice cards to get paginated posts
  const paginatedCards = cards.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    changeCurrentEventPage(value)

    let win: any = window //standalone app

    if (parent) //case of an iframe
    {
      win = parent
    }

    win.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

  };


  let issetFilters = false
  const checkFilters = () => {
    if (filters.SectorEvent !== '' || filters.Types !== '' || filters.Groups !== '' || filters.Formats !== '' || filters.SectorGroups !== '')
      issetFilters = true
  }
  checkFilters()
  //console.log(issetFilters)


  return (
    <Grid container style={{ width: '100%', margin: '2rem auto 0' }}>
      <Grid item xs={12}>

        <div className={renderStyleifPublished()} >
          {cards.length > 0 ? (
            paginatedCards.map((card: any, i: any) => {
              //console.log(card.EventURL)
              return (
                <React.Fragment key={`events-${i}`}>

                  {card.EventURL === '' || card.EventURL == null
                    ?
                    //<Link to={`/sessions/${card.id}`} data-span="4" className="statementcard ituCard" >
                    <StatementCardEvents key={card.id} data={card} datasource={datasource} />
                    //</Link>
                    :
                    //<Link to={card.EventURL} target="_blank" data-span="4" className="statementcard ituCard" >
                    <StatementCardEvents key={card.id} data={card} datasource={datasource} />
                    //</Link>
                  }
                </React.Fragment>

              );
            },


            )

          ) : (!issetFilters ? (
            <div className={renderStyleifPublished()}>

              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>

              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>


              <Box data-span="4" sx={{ width: 390, height: 320, marginRight: 0.5, my: 5 }}>

                <Skeleton
                  animation="pulse"
                  sx={{ bgcolor: loadingBgColor }}
                  variant="rectangular"
                  width={390}
                  height={320}
                />
                <Box sx={{ width: 390, pt: 0.5 }}>
                  <Skeleton sx={{ bgcolor: loadingBgColor }} />
                  <Skeleton sx={{ bgcolor: loadingBgColor }} width="60%" />
                </Box>

              </Box>


            </div>

          ) : (
            <div data-span="12">
              <Box data-span="12" sx={{ textAlign: 'center' }}>
                <h2>There are no events matching your filters.</h2>

                <Button
                  variant="text"
                  endIcon={<Close />}
                  style={{ color: '#6E6E6E', border: "2px solid transparent", marginTop: "1rem", fontSize: "28px" }}
                  onClick={() => resetAllFilters()}
                >
                  Reset all filters
                </Button>
              </Box>
            </div>
          ))}


        </div>
      </Grid>

      {/*pagination */}
      {cards.length > eventsPerPage ? (

        <Grid item xs={12}>
          <Stack spacing={2}>
            <Pagination count={Math.ceil(cards.length / eventsPerPage)} page={currentEventPage} onChange={handlePageChange} style={{
              justifyContent: "center",
              display: 'flex',
              marginTop: "1rem"
            }} />
          </Stack>
        </Grid>
      ) : null
      }

      {/*<div className='ituContainer' style={{ display: "flex", justifyContent: "center" }}>
        <h2>There are no events matching your filters.</h2>

        <Button
          variant="text"
          endIcon={<Close />}
          style={{ color: '#6E6E6E', border: "2px solid transparent", marginTop: "1rem", fontSize: "28px" }}
          onClick={() => resetAllFilters()}
        >
          Reset all filters
        </Button>
    </div>*/}
    </Grid>

  );
};

export default CardViewEvents;
